import type {ReactAction} from '@netx/core/bootstrap';
import {faQuestionCircle} from '@netx/core-icons';
import {actionsToOrderedActions} from '@netx/core-next/utils/actions/actionsToOrderedActions';
import {UserActionLabel} from '../locales';
import {
	appActionContactRoute,
	appActionHelpCenter,
} from '@netx/core-app-next/actions';

export const userActionHelpIcon = faQuestionCircle;

/**
 * @param params
 * @returns Action
 */
export const userActionHelp = (params?: Partial<ReactAction>): ReactAction => ({
	name: 'user-help',
	cb: () => {},
	icon: userActionHelpIcon,
	get label() {
		return UserActionLabel.HELP;
	},
	...params,
	showChildWhenOnly: true,
	children: actionsToOrderedActions([
		appActionHelpCenter(),
		appActionContactRoute(),
	]),
});

export default userActionHelp;
